import * as THREE from "../../../../libs/three.js/build/three.module.js";

import math from '../../utils/math.js'
import Tween from '../../utils/Tween.js'
import {easing,  lerp} from '../../utils/transitions.js'

//有的动画，如小狗，进来如果不play停在第一帧，mesh会错，爪子在前面；但如果都停在第一帧，动作有可能很奇怪

const tweens = {}
const maxClipFadeTime = Potree.settings.maxClipFadeTime//渐变时间 s
const pathStates = new Map
//actions中可能包含没有动作的 如TPose

//包括无动画的模型在内的各项属性的过渡
export default class AnimationEditor extends THREE.EventDispatcher{
    constructor(){
        super()
        
        
        this.poseKeys = new Map  //transform
        this.descKeys = new Map  //字幕
        this.pathKeys = new Map  //之前设置好的Path  , 优先级高于pose
        this.clipKeys = new Map  //glb animation actions  


        this.duration = 0 //动画时长
        this.time = 0 //当前播放时间
        this.cursorTime = 0 //时间轴指针时间
    }
    
    addKey(model, keyType, key ){
        let keys = this[keyType+'Keys'].get(model)
        if(!keys){
            keys = []
        }
        
        let index = keys.findIndex(e=>e.time>key.time)
        if(index == -1){
            index = keys.length
        }
        
        
        keys = [...keys.slice(0,index), key, ...keys.slice(index,keys.length)]
        this[keyType+'Keys'].set(model,keys)
        this.updateTimeRange()
    }
    
    removeKey(model, keyType, key  ){
        let keys = this[keyType+'Keys'].get(model)
        if(!keys)return console.warn('removeKey没找到key')
      
        let index = keys.indexOf(key)
        index > -1 && keys.splice(index,1)
        this.updateTimeRange()        
    }
    
    reOrderKey(model, keyType, key  ){
        this.removeKey(model, keyType, key )
        this.addKey(model, keyType, key )
    }
    
    
    at(time, delta, force){ 
        this.dispatchEvent({type:'atTime', time})   //该时间可以大于本动画持续时间
        this.cursorTime = time
        if(time > this.duration + maxClipFadeTime/2){  
            for(let [model, keys] of this.clipKeys){
                model.actions.forEach(a=>a.stop())
            } 
        }
        
        let maxTime = this.duration+maxClipFadeTime/2
        if(time >= maxTime) time = maxTime 
        if(this.time == time && !force)return
        this.time = time //真实值
        
        let transitionRatio = 0.05 * delta * 60 //渐变系数，越小缓动程度越高，越平滑 //假设标准帧率为60fps，当帧率低时（delta大时） 降低缓动。速度快时缓动太高会偏移路径
      
        
        for(let [model, keys] of this.pathKeys){//路径。开头结尾和别的衔接过渡
            let atPath //是否在path中 至多只有一个 
            let fadeToPath//是否在过渡到path中
            let fadeFromPath //是否从path中过渡到下一pose
            //以上三个权重越来越小，但都比pose大
            keys.find(key=>{
                if(key.path.points.length < 2) return
                let startToFade = key.time - maxClipFadeTime/2
                let endFade = key.time + key.dur + maxClipFadeTime/2
                atPath = time >= key.time && time <= key.time + key.dur
                if(atPath){
                    atPath = key //找到一个就退出 
                    return true
                }else if(delta!=void 0){ //有delta代表是播放时，要缓动，如果是点击时间轴到这一帧，就不缓动
                    if(time > startToFade && time < key.time){
                        fadeToPath = key
                    }else if(!fadeToPath && time > key.time + key.dur && time < endFade){
                        fadeFromPath = key
                    }
                }
            })
            pathStates.set(model,{atPath,fadeToPath,fadeFromPath})
            
            
            if(atPath){//沿着curve行走，目视curve前方  （参照CameraAnimationCurve，搜quaFromCurveTan）
                let percent = (time - atPath.time) / atPath.dur
                let {position , quaternion} = this.getPoseAtPathKey(atPath, percent)
                model.position.copy(position);
                quaternion && model.quaternion.copy(quaternion)  
            }else if(fadeToPath){ 
                let {position , quaternion} = this.getPoseAtPathKey(fadeToPath, 0)
                quaternion && lerp.quaternion(model.quaternion, quaternion)(transitionRatio) //每次只改变一点点  
                lerp.vector(model.position, position)(transitionRatio) 
            }
            
            if(atPath || fadeToPath){
                model.dispatchEvent('position_changed') //暂时都这么写，以后再判断是否真的改变了
                model.dispatchEvent('rotation_changed') 
            }
            
        }
        
        
        
        
        
        for(let [model, keys] of this.poseKeys){
            /* keys = keys.filter(e=>e.pos && e.scale && e.qua)*/ 
            if(keys.length == 0) continue 
            let {atPath, fadeFromPath, fadeToPath} = pathStates.get(model) || {}
              
            tweens.scale = new Tween(keys.map(e=>e.time), keys.map(e=>e.scale)) 
            model.scale.copy(tweens.scale.lerp(time))
             
            if(!atPath && !fadeToPath){
                tweens.pos = new Tween(keys.map(e=>e.time), keys.map(e=>e.pos))
                tweens.qua = new Tween(keys.map(e=>e.time), keys.map(e=>e.qua))
                
                let time_ = time 
                if(fadeFromPath){  //但如果开始播放时模型已经在fadeFromPath这个区间里，也是直接过渡过去
                    time_ = fadeFromPath.time + fadeFromPath.dur + maxClipFadeTime/2 //fadeTimeEnd
                }  
                let position = tweens.pos.lerp(time_)
                let quaternion = tweens.qua.lerp(time_)
                if(fadeFromPath){  
                    lerp.quaternion(model.quaternion, quaternion)(transitionRatio) //每次只改变一点点  
                    lerp.vector(model.position, position)(transitionRatio) 
                }else{
                    model.position.copy(position)
                    model.quaternion.copy(quaternion)
                } 
                
            } 
           
            model.dispatchEvent('position_changed')
            model.dispatchEvent('rotation_changed') 
         
        } 
        
        
        
        
        
        for(let [model, keys] of this.clipKeys){
            if(keys.length == 0) continue 
            let weights = keys.map((key,i)=>{ //计算每个动作权重（幅度）。  
                
                if(delta == void 0){//无缓动 
                    return time > key.time && time < key.time + key.dur ? 1 : 0
                }
                
                let fadeTimeStart = Math.min(maxClipFadeTime,  key.dur, (keys[i-1]?.dur || maxClipFadeTime  )) / 2 //过渡时间不超过当前和前一个的 half of dur
                let fadeTimeEnd = Math.min(maxClipFadeTime,  key.dur, (keys[i+1]?.dur || maxClipFadeTime  )) / 2   //过渡时间不超过当前和后一个的 half of dur
                
                
                let startTime2 = key.time + fadeTimeStart     
                let endTime2 = key.time + key.dur - fadeTimeEnd 
                if(time >= startTime2 && time <= endTime2 ) return 1
                 
                let startTime1 = key.time - fadeTimeStart 
                let endTime1 = key.time + key.dur + fadeTimeEnd 
                if(time < startTime1 || time > endTime1)return 0  //out bound 
                    
                if(time < startTime2 ){
                    return Potree.math.linearClamp(time, [startTime1,startTime2],[0,1])
                }else{
                    return Potree.math.linearClamp(time, [endTime2,endTime1],[1,0])
                }
            })//最多有两个>0的，在过渡, 且能保证两个是不同的action
             
            let animateActions = [] //在播的动作
            keys.forEach((key,i)=>{ weights[i]>0 && !animateActions.includes(key.action) && animateActions.push(key.action)})
            
             
            keys.forEach((key,i)=>{ 
                if(animateActions.includes(key.action)){
                    let weight = weights[i] * key.weight    //权重乘以自身幅度
                    if(weight>0){
                        key.action.play() 
                        key.action.setEffectiveTimeScale(weights[i] * key.speed) //乘以一个weight缓动
                        key.action.setEffectiveWeight( weight );
                    }
                }else{
                    key.action.stop()
                }
            }) 
            //model.mixer.timeScale = 1 ;
            
        }
        
        
        { 
            if(this.camFollowObject){//in front of model
                let dir = new THREE.Vector3(0,0.1,1).normalize()//稍微朝上
                
                if(this.camFollowObject.length == 1){
                    let dis = 4; 
                    let model = this.camFollowObject[0] 
                    dir.multiplyScalar(dis).applyQuaternion(model.quaternion)
                    let pos = new THREE.Vector3().addVectors(model.boundCenter, dir)
                    viewer.mainViewport.view.position.copy(pos)
                    viewer.mainViewport.view.lookAt(model.boundCenter)
                }else{ 
                    /* let dirAve = new THREE.Vector3
                    this.camFollowObject.forEach(model=>{
                        dirAve.add(dir.clone().applyQuaternion(model.quaternion))
                    }) */
                    viewer.modules.MergeEditor.focusOn(this.camFollowObject, 0, true/* ,false,dirAve */) 
                }
            } 
        }
        
        
        
        
        viewer.dispatchEvent('content_changed')
       
    }
    
    getPoseAtPathKey(key, percent){ 
        let percent2 = percent + 0.001 
        let curve = key.path.curve.clone()
        if(key.reverse) curve.points.reverse()  
        let position = curve.getPointAt(percent); 
        let quaternion
        if(percent2 <= 1){
            let position2 = curve.getPointAt(percent2);
            quaternion = math.getQuaFromPosAim(position2, position)  
        }
        return {position, quaternion}
    }
    
    
    
    play({camFollowObject, time = -maxClipFadeTime/2}={}){//动画时长比duration多一个maxClipFadeTime，为了给开始和结束动画过渡
        
     
        this.updateTimeRange()
        this.setCameraFollow(camFollowObject)
        this.playing && this.pause()
        
      
        let maxTime = this.duration+maxClipFadeTime/2
        this.playing = true
        
        this.cursorTime = time
        
        this.onUpdate = (e)=>{ 
            this.cursorTime += e.delta 
            if(!Potree.settings.isOfficial && time >= maxTime) this.cursorTime = maxTime 
            this.at(this.cursorTime, e.delta) 
            if(!Potree.settings.isOfficial && time >= maxTime) {
                this.dispatchEvent('stop')
                this.pause()
            }
              
        }
        viewer.addEventListener("update", this.onUpdate);
          
    }  
    
    pause(){
        this.playing = false 
        viewer.removeEventListener("update", this.onUpdate); 
        for(let [model, keys] of this.clipKeys){
            model.actions.forEach(a=>a.stop())
        } 
        viewer.dispatchEvent('content_changed')
        
    }
    
    
    setCameraFollow(camFollowObject){//for test
        this.camFollowObject = camFollowObject
        if(!camFollowObject)return
        
        Potree.settings.displayMode = 'showPointCloud'
        
        if(!(this.camFollowObject instanceof Array)){//支持相机跟随多个物体，对着bound的中心
            this.camFollowObject = [this.camFollowObject]
        }
        
        this.camFollowObject = this.camFollowObject.map(object=>{
            if(typeof object == 'string'){
                return viewer.objs.children.find(e=>e.name == object)
            }else{
                return object
            }
        })
        
    }
    
    
    updateTimeRange(){
        let maxTime = 0
        for(let [model, keys] of this.poseKeys){
            keys.length>0 && (maxTime = Math.max(maxTime, keys[keys.length - 1].time))
        }
        
        for(let [model, keys] of this.clipKeys){
            keys.length>0 && (maxTime = Math.max(maxTime, keys[keys.length - 1].time + keys[keys.length - 1].dur))
        }
        
        for(let [model, keys] of this.pathKeys){
            keys.length>0 && (maxTime = Math.max(maxTime, keys[keys.length - 1].time + keys[keys.length - 1].dur))
        }
        this.duration = maxTime //不算开始和结束动画的过渡时间的话
        
        
        /* for(let [model, keys] of this.clipKeys){
            max = Math.max(maxTime, keys[keys.length - 1].time + keys[keys.length - 1].dur)
        } */
    }
    
    
    /* removeModelCallback(model){
        this.poseKeys.get
    } */
    
    
    /////////////////////////////////
    
    
    addPoseKey({model,time,index }={}){ 
        /* if(replace){ 
            this.removeKey(model,'pose', index)
        } */
        let keys = this.poseKeys.get(model)
        if(!keys){
            keys = []  
        }
        let key = {
            time,
            qua: model.quaternion.clone(),
            scale: model.scale.clone(),
            pos: model.position.clone()
        } 
        if(index == void 0)index = keys.length 
        keys = [...keys.slice(0,index), key, ...keys.slice(index,keys.length)]
		this.poseKeys.set(model,keys)
        return key
    }
    
    
     
    addClipKey({model, time, index, dur, actionIndex, weight=1, speed=1/* , replace  */}={}){
        
        /* if(replace){
            this.removeKey(model,'clip',index)
        } */
        let keys = this.clipKeys.get(model)
        if(!keys){
            keys = []  
        }
        let key = {
            time,   //startTime
            dur,    
            action: model.actions[actionIndex],
            speed, weight,
        } 
        if(index == void 0)index = keys.length 
        keys = [...keys.slice(0,index), key, ...keys.slice(index,keys.length)]
		this.clipKeys.set(model,keys)
    } 
    
    
    
    addPathKey({model, time, index, dur, path/* , replace */ }={}){//what if path is deleted ? 
        /* if(replace){
            this.removeKey(model,'path',index)
        } */
        let keys = this.pathKeys.get(model)
        if(!keys){
            keys = []  
        }
        let key = {
            time,   //startTime
            dur,    
            path,  
        } 
        if(index == void 0)index = keys.length 
        keys = [...keys.slice(0,index), key, ...keys.slice(index,keys.length)]
		this.pathKeys.set(model,keys)
    } 
    
    addDescKey({model, time, index, dur, desc/* , replace */ }={}){
        /* if(replace){
            this.removeKey(model,'desc',index)
        }  */       
        let keys = this.descKeys.get(model)
        if(!keys){
            keys = []  
        }
        let key = {
            time,   //startTime
            dur,    
            desc, 
        } 
        if(index == void 0)index = keys.length 
        keys = [...keys.slice(0,index), key, ...keys.slice(index,keys.length)]
		this.descKeys.set(model,keys)
    } 
    
    
    
    
    
    save(){//for test, 注意保证每个模型名字不同
        let data = {poseKeys:{}, clipKeys:{}}
        for(let [model, keys] of this.clipKeys){
            data.clipKeys[model.name] = keys.map(key=>{
                return {
                    actionIndex: model.actions.indexOf(key.action),
                    time: key.time, dur:key.dur, weight:key.weight,  speed:key.speed
                }
            })
        }
        
        for(let [model, keys] of this.poseKeys){
            data.poseKeys[model.name] = keys.map(key=>{
                return {
                    qua: key.qua.toArray(), pos: key.pos.toArray(), scale:key.scale.toArray(),
                    time: key.time,  
                }
            })
        }
        console.log(JSON.stringify(data))
        return data 
    }
    
    
    buildFromData(data){
        if(typeof data == 'string'){
            data = JSON.parse(data)
        }
        for(let name in data.poseKeys){
            let model = viewer.objs.children.find(e=>e.name == name)
            if(!model){
                console.warn('没找到pose模型',name)
                continue
            }
            let keys = data.poseKeys[name].map(e=>{
                return {
                    qua: new THREE.Quaternion().fromArray(e.qua),
                    pos: new THREE.Vector3().fromArray(e.pos),
                    scale: new THREE.Vector3().fromArray(e.scale),
                    time: e.time
                }
            })
            this.poseKeys.set(model,keys)
        }
        
        for(let name in data.clipKeys){
            let model = viewer.objs.children.find(e=>e.name == name)
            if(!model){
                console.warn('没找到clip模型',name)
                continue
            }
            let keys = data.clipKeys[name].map(e=>{
                return {
                    action: model.actions[e.actionIndex], 
                    time: e.time, dur: e.dur, weight:e.weight, speed:e.speed
                }
            })
            this.clipKeys.set(model,keys)
        }
    }
    
    
    
    
    
}






/* 
function executeCrossFade( startAction, endAction, duration ) {
    // Not only the start action, but also the end action must get a weight of 1 before fading
    // (concerning the start action this is already guaranteed in this place)
    if ( endAction ) {

        setWeight( endAction, 1 );
        endAction.time = 0;

        if ( startAction ) {
            // Crossfade with warping
            startAction.crossFadeTo( endAction, duration, true );

        } else {
            // Fade in
            endAction.fadeIn( duration );
        }

    } else {
        // Fade out
        startAction.fadeOut( duration );
    }

}


function setWeight( action, weight ) {

    action.enabled = true;
    window.ani1 || action.setEffectiveTimeScale( 1 );
    action.setEffectiveWeight( weight );

} */

 

/* autoActionSpeed(action){ //要获取这段时间走过的路程很难，还是延期吧
    return  dis / dur
} */
/* 

 动作自动计算步伐 幅度（weight）或 速度


  timeScale * modelStepSizeRatio * weight = dis / dur
  速度       每个模型的步长系数    幅度

 


 */